// extracted by mini-css-extract-plugin
module.exports = {"modal":"SavingDialog_modal__3VLds","logoContainer":"SavingDialog_logoContainer__migM2","logo":"SavingDialog_logo__1xU-B","text":"SavingDialog_text__b3bGY"};